import React, { useState, useRef } from "react";
import { Tabs, Tab } from "react-bootstrap";
import CohortFiller from "./CohortPillar";
// import VerticalSwitch from "./VerticalSwitch";
import "../../styles/CohortPillar.css";

const CohortButton = () => {
  const [activeKey, setActiveKey] = useState("pillars");
  const [showTabs, setShowTabs] = useState(false);

  const pillarRef = useRef(null);
  const tabsRef = useRef(null);

  const details = {
    pillars: {
      Mentorship:
        "Guided by industry leaders, WiSE provides one-on-one and group mentorship to help women navigate challenges, gain clarity, and accelerate growth in the semiconductor ecosystem.",
      "Events and Meetups":
        "WiSE hosts knowledge-sharing sessions, webinars, and industry leader talks that spark dialogue, build networks, and create meaningful impact.",
      Storytelling:
        "Every story matters. Through blogs, features, and spotlights, WiSE amplifies women’s voices, celebrates achievements, and inspires the next generation.",
      "Projects and Training":
        "Hands-on projects and collaborations provide members with practical experience and innovation opportunities.",
    },
    cohort: {
      Crawl: {
        years: "0–2 years",
        description:
          "WiSE hosts knowledge-sharing sessions, webinars, and industry leader talks that spark dialogue, build networks, and create meaningful impact.",
      },
      "Climb and Consolidate": {
        years: "3–7 years",
        description:
          "Guided by industry leaders, WiSE provides one-on-one and group mentorship to accelerate growth.",
      },
      "Cultivate and Craft": {
        years: "8–15 years",
        description:
          "Hands-on projects and collaborations provide practical experience and innovation opportunities.",
      },
      Command: {
        years: "15+ years",
        description:
          "Through blogs and spotlights, WiSE amplifies women's voices and inspires the next generation.",
      },
      Comeback: {
        years: "Re-entry",
        description:
          "Projects and collaborations help women re-enter the semiconductor workspace.",
      },
    },

    programs: {
      "Career Entrench":
        "WiSE hosts knowledge-sharing sessions, webinars, and industry leader talks that spark dialogue, build networks, and create meaningful impact. Offline meetups foster camaraderie, collaboration, and a sense of belonging among women in semiconductors.",
      "Career Advance":
        "Guided by industry leaders, WiSE provides one-on-one and group mentorship to help women navigate challenges, gain clarity, and accelerate growth in the semiconductor ecosystem.",
      "Career Coach":
        "Hands-on projects and collaborations provide members with practical experience, innovation opportunities, and a chance to showcase skills to the wider industry.",
      "Campus to Career":
        "Every story matters. Through blogs, features, and spotlights, WiSE amplifies women’s voices, celebrates achievements, and inspires the next generation.",
      Reignite:
        "Hands-on projects and collaborations provide members with practical experience, innovation opportunities, and a chance to showcase skills to the wider industry.",
    },
  };

  // Toggle vertical switch & scroll
  const handleToggle = () => {
    setShowTabs((prev) => {
      const next = !prev;

      if (next && tabsRef.current) {
        tabsRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      } else if (!next && pillarRef.current) {
        pillarRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }

      return next;
    });
  };

  return (
    <div>
      {/* Floating vertical switch */}
      {/* <div className="floating-vertical-switch">
        <VerticalSwitch
          isOn={showTabs}
          onToggle={handleToggle}
          labels={["Pillars", "Tabs"]}
        />
      </div> */}

      {/* === Heading + Subtitle + Cohort Pillar === */}
      <div className="cohort-wrapper pt-0" ref={pillarRef}>
        <div className="cohort-header">
          <h1 className="cohort-heading ">Cohort Structure</h1>
          <p className="cohort-subtitle">
            Empowering women through mentorship, innovation, and collaboration
            in the semiconductor industry.
          </p>
        </div>

        <CohortFiller />
      </div>

      {/* Tabs Section */}
      <div className="CohortTabs" ref={tabsRef}>
        <Tabs
          id="cohort-tabs"
          activeKey={activeKey}
          onSelect={(k) => setActiveKey(k)}
          className="mb-4"
          fill
        >
          <Tab eventKey="pillars" title="Pillars">
            <TabContent items={details.pillars} />
          </Tab>

          <Tab eventKey="cohort" title="Cohort">
            <TabContent items={details.cohort} />
          </Tab>

          <Tab eventKey="programs" title="Programs">
            <TabContent items={details.programs} />
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

// Tab content renderer
const TabContent = ({ items }) => (
  <div className="tab-content-wrapper">
    {Object.entries(items).map(([title, data]) => {
      const isObject = typeof data === "object";

      return (
        <div key={title} className="tab-item">
          <h2 className="tab-title">
            {title}
            {/* Only Cohort items have years */}
            {isObject && data.years && (
              <span className="years-label"> ({data.years})</span>
            )}
          </h2>

          <p>{isObject ? data.description : data}</p>
        </div>
      );
    })}
  </div>
);

export default CohortButton;
